<template>
  <div class="business-information-com">
    <jw-modal :visible="visible" @cancel="correlationClose" class="information-modal" :mask-closable="false" :body-style="{ height: '500px' }">
      <template #title> {{ $t('关联工商信息') }} </template>
      <div class="message-title">
        <p class="company-content">
          <jw-input-search @blur="getSerachData(name)" @keyup.enter="getSerachData(name)" @clear="getSerachData(name)" @search="getSerachData(name)" v-model="name" allow-clear> </jw-input-search>
        </p>
      </div>
      <jw-spin :loading="loading">
        <template v-if="list?.length">
          <div class="list-content">
            <div v-for="item in list" :key="item.id" class="company-name-item">
              <div class="company-content mb-10">
                <div>
                  <span class="company-name">{{ item.name }}</span> <jw-tag :color="item.regStatus == '存续' ? 'green' : 'red'" bordered size="small">{{ item.regStatus ? item.regStatus : '-' }}</jw-tag>
                </div>
                <jw-button @click="selectCustomer(item)" size="small" type="primary" style="margin-left: 30px">{{ $t('关联') }}</jw-button>
              </div>
              <div class="registeredfund-item mb-10">
                <span>
                  <span class="message-with">{{ $t('法人') }}：</span>{{ item.legalPersonName ? item.legalPersonName : '-' }} <span class="line">|</span></span
                >
                <span>
                  <span class="message-with">{{ $t('注册资本') }}：</span>{{ item.regCapital ? item.regCapital : '-' }}<span class="line">|</span></span
                >
                <span>
                  <span class="message-with">{{ $t('成立日期') }}：</span>{{ item.estiblishTime ? item.estiblishTime : '-' }}</span
                >
              </div>
              <div class="information-code mb-10">
                <span class="message-with">{{ $t('统一社会信用代码') }}：</span>{{ item.creditCode ? item.creditCode : '-' }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <jw-empty class="eltimeline" :img-src="imgSvg"> {{ $t('暂无数据') }} </jw-empty>
        </template>
      </jw-spin>

      <template #footer v-if="list?.length">
        <jw-space>
          <jw-pagination :total="total" :current="page" :page-size="pageSize" show-total @change="next" />
        </jw-space>
      </template>
      <template #footer v-else>
        <jw-space>
          <jw-button type="primary" @click="correlationClose">{{ $t('取消') }}</jw-button>
        </jw-space>
      </template>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, toRefs, inject } from 'vue';
import { clientService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import imgSvg from '@/assets/images/img-no-record.svg';
import useLoading from '@/hooks/loading';
export default {
  name: 'XlBusinessInformation',
  setup(props, ctx) {
    const { t } = useI18n();
    const data = reactive({
      id: inject('defaultParams')?.id,
      visible: false,
      list: [],
      pageSize: 10,
      page: 1,
      name: '',
      total: 0,
      from: '' //页面来源
    });
    const { loading, setLoading } = useLoading(true);
    const getSerachData = (val) => {
      data.name = val;
      getCustomerQcc();
    };
    //选择 关联
    const selectCustomer = (item) => {
      if (data.from == 'index-list') {
        qccBind(item);
      } else {
        ctx.emit('cb', item);
        data.visible = false;
      }
    };
    //获取绑定的工商id
    const qccBind = async (item) => {
      const params = {
        id: data.id,
        qccId: item.id
      };
      try {
        const json = await clientService.qccBind(params);
        if (!json.error) {
          Message.success(t('操作成功'));
          data.visible = false;
          ctx.emit('cb', item);
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        data.visible = false;
        // Message.error(e.message || e.statusText || '操作失败');
      }
    };
    // 查询客户天眼查信息
    const getCustomerQcc = async () => {
      setLoading(true);
      const params = {
        name: data.name,
        pageSize: data.pageSize,
        page: data.page
      };
      try {
        const json = await clientService.customerQccSearch(params);
        if (!json.error) {
          if (json.result?.records) {
            data.list = json.result?.records;
          } else {
            data.list = [];
          }
          data.total = json.result?.total;
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    const next = (current) => {
      data.page = current;
      getCustomerQcc();
    };
    //关闭
    const correlationClose = () => {
      data.page = 1;
      data.visible = false;
    };
    //打开弹窗
    const correlationOpen = async (name, from) => {
      data.list = [];
      data.page = 1;
      data.name = name;
      data.from = from || '';
      await getCustomerQcc();
      data.visible = true;
    };
    return {
      correlationClose,
      correlationOpen,
      next,
      getCustomerQcc,
      selectCustomer,
      imgSvg,
      loading,
      getSerachData,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-business-information.less';
</style>
<style lang="less">
.information-modal {
  .arco-modal-body {
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    padding: 0;
  }

  .arco-modal-header {
    justify-content: end;
  }

  .arco-modal-header .arco-modal-title-align-center {
    justify-content: flex-start;
  }

  .arco-modal-title {
    justify-content: flex-start;
  }

  .arco-modal-footer {
    border-top: none;
  }

  .arco-input-wrapper {
    width: 290px;
  }

  .arco-spin-loading {
    width: 100%;
    height: 100%;
  }

  .arco-spin {
    width: 100%;
    height: 100%;
  }
}
</style>
